import { css } from '@linaria/core';
export const Normalize = css `
	:global() {
		html {
			line-height: 1.15;
			-webkit-text-size-adjust: 100%;
		}

		body {
			margin: 0;
		}

		main {
			display: block;
		}
		hr {
			overflow: visible;
			box-sizing: content-box;
			height: 0;
		}

		pre {
			font-family: monospace;
		}

		a {
			background-color: transparent;
		}

		b,
		strong {
			font-weight: 600;
		}

		code,
		kbd,
		samp {
			font-family: monospace;
		}

		small {
			font-size: 80%;
		}

		sub,
		sup {
			position: relative;
			font-size: 75%;
			line-height: 0;
			vertical-align: baseline;
		}

		sub {
			bottom: -0.25em;
		}

		sup {
			top: -0.5em;
		}

		img {
			border-style: none;
		}

		button,
		input,
		optgroup,
		select,
		textarea {
			margin: 0;
		}

		button,
		input {
			overflow: visible;
		}

		button,
		select {
			text-transform: none;
		}

		fieldset {
			padding: 0.35em 0.75em 0.625em;
		}

		details {
			display: block;
		}

		summary {
			display: list-item;
		}

		template {
			display: none;
		}

		[hidden] {
			display: none;
		}
	}
`;
